import CardBroadbandLabel from "components/Browse/CardBroadbandLabel";
import SidegradesSection from "./SidegradesSection";

const InternetSection: React.FC<{
  product: any;
  index: number;
  labelImageUrl: string;
  label: string;
  postCustomerSummaryRequest: Function;
}> = ({ product, index, labelImageUrl, label, postCustomerSummaryRequest }) => {
  const getPremiumWifiImage = (serviceOptions: any, productId: number) => {
    const serviceOption = serviceOptions.find((option: any) => option.serviceOptionContent.id === productId);

    if (serviceOption) {
      const contentEcommerce = serviceOption.serviceOptionContent.contentEcommerce;
      const iconItem = contentEcommerce.find((item: any) => item.fieldName === "icon");

      if (iconItem) {
        return iconItem.fileURL;
      }
    }

    return null;
  };
  const speedunitsCurrentProduct =
    product.speedDown && product.speedDownUnits && product.speedUp && product.speedUpUnits ? (
      <h6 className="speed-units">
        {product.speedDown} {product.speedDownUnits} x {product.speedUp} {product.speedUpUnits}
      </h6>
    ) : null;

  const sortedInternetProducts =
    product?.upgrades?.length > 0
      ? [...product?.upgrades].sort((a: any, b: any) => {
          if (a.isPremiumWifi && !b.isPremiumWifi) return 1; // Move Premium WiFi to the end
          if (!a.isPremiumWifi && b.isPremiumWifi) return -1;
          return a.productId - b.productId; // Otherwise, sort by productId
        })
      : [];

  const browseProductsOrDisplayMessage = () => {
    let needToCallIn = product.hasService && (product.productId === 0 || !product.canUpgrade);

    return (
      <div className="select-internet-products">
        {needToCallIn ? (
          <>
            <div className="browse-products-message">
              <strong>Change Internet Plan.</strong>
            </div>
            <div className="gap-2 btn-container">
              <div style={{ fontSize: "14px", width: "200px" }}>
                Call <a href="tel:1-888-403-2667">1-888-403-2667</a> to verify available upgrades.
              </div>
              <a className="btn btn-primary browse-products-button" type="button" href="tel:1-888-403-2667">
                <strong>Call Now</strong>
              </a>
            </div>
          </>
        ) : (
          <>
            {!product.hasService ? (
              <div className="select-internet-products">
                <div className="browse-products-message">
                  <strong>Select "Browse Products" below to choose from available services in your area.</strong>
                </div>
                <div className="d-grid gap-2 btn-container">
                  <button className="btn btn-primary browse-products-button" type="button" onClick={() => postCustomerSummaryRequest("HSI", null)}>
                    <strong>Browse Products</strong>
                  </button>
                </div>
              </div>
            ) : null}
          </>
        )}
      </div>
    );
  };

  const removeZeroMonthsTerm = (term: string) => {
    if (term.includes("for 0 month")) {
      return term.replace("for 0 month.", "").trim();
    }

    if (term.includes("for 360 months")) {
      return term.replace("for 360 months.", "").trim();
    }

    return term;
  };

  return (
    <div key={`int-${index}`} className="customer-summary-internet-section">
      <div className="core-type-container mb-5 mt-5">
        <img className="core-type-image" src={labelImageUrl} alt="Comporium" />
        <h2 className="core-type-label">{label}</h2>
      </div>
      <div className="core-type-product-card">
        {product?.sidegrade ? (
          <SidegradesSection
            sidegrade={product.sidegrade}
            removeZeroMonthsTerm={removeZeroMonthsTerm}
            postCustomerSummaryRequest={postCustomerSummaryRequest}
            getPremiumWifiImage={getPremiumWifiImage}
            isTechUpgrade={product.sidegrade.productId === product.productId}
          />
        ) : null}
        {/* This HTML block represents the existing internet product that the customer currently possesses. */}
        {product?.cardName && product.productId > 0 ? (
          <div key={`item.cardName-${index}`} className="product-card-container me-2">
            <div className="current-product-card me-2">
              <div className="d-flex justify-content-center w-100">
                <div className="flair-flag"></div>
              </div>
              <div className="product-details">
                <h5 className="text-center">{product.cardName}</h5>
                {speedunitsCurrentProduct}
                {product?.termPrice ? <p>{product.termPrice}</p> : null}
              </div>
              <div
                className="current-product-footer"
                onClick={() => (product.currentPlanHelpCenterLink ? window.open(product.currentPlanHelpCenterLink, "_blank") : false)}
                style={product.currentPlanHelpCenterLink ? { cursor: "pointer" } : {}}
              >
                CURRENT PLAN
              </div>
            </div>
            {product?.currentProductLabel ? <CardBroadbandLabel broadbandLabel={product.currentProductLabel} /> : null}
          </div>
        ) : null}
        {/* This HTML block are product upgrades available for the customer */}
        {product?.upgrades?.length > 0 ? (
          sortedInternetProducts.map((item: any, index: number) => {
            return (
              <div key={`item.cardName-${index}`} className="product-card-container me-2 mb-2">
                <div className="product-card">
                  <div className="product-details">
                    {item.isPremiumWifi ? (
                      <img src={getPremiumWifiImage(product.serviceOptions, item.productId)} alt="Comporium" className="product-image" />
                    ) : null}
                    <h5 style={item.isPremiumWifi ? { fontSize: "18px", marginTop: "15px" } : {}}>{item.cardName}</h5>
                    <h6 className="product-description">{item.description}</h6>
                    <p className="promotion-description">{item.price ? item.price : removeZeroMonthsTerm(item.promotionDescription)}</p>
                  </div>
                  <div className="product-footer cursor-pointer" onClick={() => postCustomerSummaryRequest("HSI", item)}>
                    {item.isPremiumWifi ? "ADD PREMIUM WIFI KIT" : "UPGRADE NOW"}
                  </div>
                </div>
                {item.upgradeLabel ? <CardBroadbandLabel broadbandLabel={item.upgradeLabel} /> : null}
              </div>
            );
          })
        ) : (
          <>{browseProductsOrDisplayMessage()}</>
        )}
      </div>
    </div>
  );
};

export default InternetSection;
